import { get, post } from "../http-client/client";
import { ApiResponse } from "../http-client/Response";

export interface Organization {
  id: string;
  name: string;
  displayName?: string | null;
  /** Workspace (e.g. Alfa Laval): members are invited by email only */
  isWorkspace?: boolean;
  subscriptionCount: number;
  subscriptionEndDate: Date;
}

export const getAllOrganizations = (): Promise<ApiResponse<Organization[]>> => {
  return get(`/organizations`, null);
};

export const createOrganization = (name: string): Promise<ApiResponse<Organization>> => {
  return post(`/organizations`, { name });
};
